import {useEffect, useState} from "react";
import {useDispatch, useSelector} from "react-redux";
import request from "../../../../../Services/API/Requests";
import {creatingFilter} from "../ListScreenComponent/List/Utils/creatingFilter";
import {setRefreshDataFalse} from "../../../jsonScreen.slice";

export const usePaginatedData = (listID, events = [], skipInitDataLoad = false) => {
    const stringFilter = useSelector(state => state.jsonScreen.stringFilter[listID]);
    const advancedFilter = useSelector(state => state.jsonScreen.setFilter[listID]);
    const isRefreshData = useSelector(state => state.jsonScreen.refreshData[listID]) === true;
    const userLanguage = useSelector(state => state.app.userLanguage);
    const globalValues = useSelector(state => state.jsonScreen.globalValues)
    const screenName = useSelector(state => state.jsonScreen.screenName)
    const dispatch = useDispatch();
    const pageSize = 25;
    const [page, setPage] = useState(0);
    const [filter, setFilter] = useState([]);
    const [currentLanguage, setCurrentLanguage] = useState(userLanguage)
    const [currentStringFilter, setCurrentStringFilter] = useState(stringFilter);
    const [data, setData] = useState({totalPages: 0, totalElements: 0, content: []});
    const [isLoading, setIsLoading] = useState(false);
    const hasMore = data.totalPages - 1 > page;
    const newFilter = advancedFilter ? advancedFilter.createdFilter : [];
    useEffect(() => {
        async function getInitialData() {
            if (events.length) {
                const event = events[0] || {};
                if (event.event === 'onLoad') {
                    if (event.actions && event.actions.length) {
                        if (event.actions[0].type === 'setFilter') {
                            const filter = creatingFilter(event.actions[0], globalValues, screenName)
                            const response = await getData(listID, filter, stringFilter);
                            setData(response)
                            setFilter(filter)
                            setPage(0)
                            return;
                        }
                    }
                }
            }
            const response = await getData(listID, filter, stringFilter)
            setData(response)
        }

        if(!skipInitDataLoad) {
            listID && getInitialData();
        }

    }, [listID]);

    useEffect(() => {
        async function updateData() {
            if (currentStringFilter === stringFilter) return;
            const response = await getData(listID, filter, stringFilter, 0);
            setData(response);
            setCurrentStringFilter(stringFilter)
            setPage(0);
        }

        listID && updateData();
    }, [stringFilter])

    useEffect(() => {
        async function updateData() {
            if (newFilter && newFilter.length) {
                setFilter(newFilter)
                const response = await getData(listID, newFilter, stringFilter, 0);
                setData(response);
                setPage(0);
                return;
            }
            if (newFilter !== undefined) {
                if (newFilter.length === filter.length) return;
                setFilter([])
                const response = await getData(listID, [], stringFilter, 0);
                setData(response);
                setPage(0);
            }

        }

        listID && updateData();
    }, [JSON.stringify(newFilter)])
    useEffect(() => {
        if (isRefreshData) {
            dispatch(setRefreshDataFalse(listID))
            if (listID) {
                getData(listID, filter, stringFilter, 0, page * pageSize).then(res => {
                    setData(res);
                })
                setPage(0);
            }
        }
    }, [isRefreshData])

    useEffect(() => {
        async function changedLanguageData() {
            if (listID && userLanguage !== currentLanguage) {
                const response = await getData(listID, filter, stringFilter);
                setData(response)
                setCurrentLanguage(userLanguage)
            }
        }

        changedLanguageData()

    }, [userLanguage])

    async function getData(list, filter, stringFilter, pageNumber, pageSizeParam) {
        try {
            return await request({
                url: "list/getData",
                data: {
                    id: list,
                    pageSize: pageSizeParam || pageSize,
                    pageNumber: pageNumber !== undefined ? pageNumber : page,
                    textFilter: stringFilter,
                    advancedFilter: filter
                }
            });
        } catch (e) {
            console.log(e);
            return {content: []}
        }
    }

    async function loadMore() {
        if(!isLoading)
        if (page * pageSize <= data.totalElements) {
            setPage(prevState => prevState + 1);
            setIsLoading(true);
            const response = await request({
                url: "list/getData",
                data: {
                    id: listID,
                    pageSize: pageSize,
                    pageNumber: page + 1,
                    textFilter: stringFilter,
                    advancedFilter: filter
                }
            });
            setData(prevState => ({
                ...response,
                content: prevState.content.concat(response.content)
            }));
            setIsLoading(false);
        }
    }

    return [data.content, data.content.length, hasMore, loadMore]
}